<template>
    <template v-if="type === 'mstrana'">
        <a :href="`https://m-strana.ru/trustindex/company/${ slug }/`" target="_blank" class="widget-type-mstrana" ref="widgetTypeMstrana">
            <div class="widget-type-mstrana-container">
                <div class="widget-type-mstrana-tims">
                    <a :href="`https://m-strana.ru/trustindex/company/${ slug }/`" target="_blank" class="widget-type-mstrana-tims__snippet">
                        <span class="widget-type-mstrana-tims__title">Индекс надежности компании</span>
                        <span class="widget-type-mstrana-tims__link">подробнее</span>
                    </a>

                    <div class="widget-type-mstrana-tims__circle">
                        <div>
                            <ProgressCircle
                                :value="timsScore"
                                :progress-color="getStyleScore( timsScore, true, true )"
                                :shadow-color="getShadowForScoreProgress( timsScore, true )"
                                :box-shadow="getShadowForScore( timsScore )"
                                :size="timsCircleSize"
                                size-widget="small"
                                :max="10"
                            >
                                <div class="widget-type-mstrana-tims__value">
                                    <span class="widget-type-mstrana-tims__score" :style="{ color: getStyleScore( timsScore, true ) }">{{ timsScore }}</span>
                                    <IconTims class="widget-type-mstrana-tims__icon" :style="{ color: getStyleScore( timsScore, true ) }" />
                                </div>
                            </ProgressCircle>
                        </div>
                    </div>
                </div>
                
                <div class="widget-type-mstrana-separator"></div>

                <div class="widget-type-mstrana-indexes">
                    <!-- OSI -->
                    <div class="widget-type-mstrana-indexes__container">
                        <div class="widget-type-mstrana-indexes__circle">
                            <div>
                                <ProgressCircle
                                    :value="osiScore"
                                    :progress-color="getStyleScore( osiScore, true, true )"
                                    :shadow-color="getShadowForScoreProgress( osiScore, true )"
                                    :box-shadow="getShadowForScore( osiScore )"
                                    :size="'48'"
                                    size-widget="small"
                                    :max="10"
                                    transparent
                                >
                                    <div class="widget-type-mstrana-indexes__value">
                                        <IconOsi class="widget-type-mstrana-indexes__icon" />
                                        <span class="widget-type-mstrana-indexes__score" :style="{ color: getStyleScore( osiScore, true ) }">{{ osiScore }}</span>
                                    </div>
                                </ProgressCircle>
                            </div>
                        </div>

                        <div class="widget-type-mstrana-indexes__title">
                            Баллы OSI
                        </div>
                    </div>
                    <!-- END OSI -->

                    <!-- CO -->
                    <div class="widget-type-mstrana-indexes__container">
                        <div class="widget-type-mstrana-indexes__circle">
                            <div>
                                <ProgressCircle
                                    :value="coScore"
                                    :progress-color="getStyleScore( coScore, true, true )"
                                    :shadow-color="getShadowForScoreProgress( coScore, true )"
                                    :box-shadow="getShadowForScore( coScore )"
                                    :size="'48'"
                                    size-widget="small"
                                    :max="10"
                                    transparent
                                >
                                    <div class="widget-type-mstrana-indexes__value">
                                        <IconCo class="widget-type-mstrana-indexes__icon" />
                                        <span class="widget-type-mstrana-indexes__score" :style="{ color: getStyleScore( coScore, true ) }">{{ coScore }}</span>
                                    </div>
                                </ProgressCircle>
                            </div>
                        </div>

                        <div class="widget-type-mstrana-indexes__title">
                            Баллы CO
                        </div>
                    </div>
                    <!-- END CO -->

                    <!-- RMS -->
                    <div class="widget-type-mstrana-indexes__container">
                        <div class="widget-type-mstrana-indexes__circle">
                            <div>
                                <ProgressCircle
                                    :value="rmsScore"
                                    :progress-color="getStyleScore( rmsScore, true, true )"
                                    :shadow-color="getShadowForScoreProgress( rmsScore, true )"
                                    :box-shadow="getShadowForScore( rmsScore )"
                                    :size="'48'"
                                    size-widget="small"
                                    :max="10"
                                    transparent
                                >
                                    <div class="widget-type-mstrana-indexes__value">
                                        <IconRms class="widget-type-mstrana-indexes__icon" />
                                        <span class="widget-type-mstrana-indexes__score" :style="{ color: getStyleScore( rmsScore, true ) }">{{ rmsScore }}</span>
                                    </div>
                                </ProgressCircle>
                            </div>
                        </div>

                        <div class="widget-type-mstrana-indexes__title">
                            Баллы RMS
                        </div>
                    </div>
                    <!-- END RMS -->

                    <!-- SR -->
                    <div class="widget-type-mstrana-indexes__container">
                        <div class="widget-type-mstrana-indexes__circle">
                            <div>
                                <ProgressCircle
                                    :value="srScore"
                                    :progress-color="getStyleScore( srScore, true, true )"
                                    :shadow-color="getShadowForScoreProgress( srScore, true )"
                                    :box-shadow="getShadowForScore( srScore )"
                                    :size="'48'"
                                    size-widget="small"
                                    :max="10"
                                    transparent
                                >
                                    <div class="widget-type-mstrana-indexes__value">
                                        <IconSr class="widget-type-mstrana-indexes__icon" />
                                        <span class="widget-type-mstrana-indexes__score" :style="{ color: getStyleScore( srScore, true ) }">{{ srScore }}</span>
                                    </div>
                                </ProgressCircle>
                            </div>
                        </div>

                        <div class="widget-type-mstrana-indexes__title">
                            Баллы SR
                        </div>
                    </div>
                    <!-- END SR -->
                </div>

                <div class="widget-type-mstrana-logo">
                    <div>
                        <IconLogo class="widget-type-mstrana-logo__icon" />
                    </div>
                    <span class="widget-type-mstrana-logo__text">TiMs -<br />Trust Index MS</span>
                </div>
            </div>
        </a>
    </template>

    <template v-else-if="type === 'client'">
        <div class="widget-trustindex" :class="[size, theme]">
            <div class="widget-trustindex-title">
                <p>
                    Индекс надежности
                </p>
                <Skeleton v-if="loading || !company" :theme="theme" class="widget-trustindex-title__skeleton" />
                <p v-else class="widget-trustindex-title__company">
                    {{ company.name }}
                </p>
            </div>

            <div class="widget-trustindex-tims">
                <ProgressCircle
                    :value="timsScore"
                    :progress-color="getStyleScore( timsScore, true, true )"
                    :shadow-color="getShadowForScoreProgress( timsScore, true )"
                    :box-shadow="getShadowForScore( timsScore )"
                    :size="size === 'small' ? '59' : '117'"
                    :size-widget="size"
                    :max="10"
                >
                    <div class="widget-trustindex-tims__content">
                        <span class="widget-trustindex-tims__score" :style="{ color: getStyleScore( timsScore, true ) }">{{ timsScore }}</span>
                        <IconTims class="widget-trustindex-tims__icon" :style="{ color: getStyleScore( timsScore, true ) }" />
                    </div>
                </ProgressCircle>

                <div v-if="loading" class="widget-trustindex-tims__skeleton">
                    <Skeleton :theme="theme" style="width:100%;height:100%" />
                </div>
            </div>

            <div class="widget-trustindex-content">
                <div v-if="size === 'large'" class="widget-trustindex-score">
                    <div class="widget-trustindex-score__item">
                        <div class="widget-trustindex-score__name">
                            <IconOsi class="widget-trustindex-score__icon" />
                            <p class="widget-trustindex-score__title">
                                Баллы OSI
                            </p>
                        </div>

                        <Skeleton v-if="loading" :theme="theme" class="widget-trustindex-score__skeleton" />
                        <p v-else class="widget-trustindex-score__value" :style="{ color: getStyleScore( osiScore ) }">
                            {{ osiScore }}
                        </p>
                    </div>

                    <div class="widget-trustindex-score__item">
                        <div class="widget-trustindex-score__name">
                            <IconCo class="widget-trustindex-score__icon" />
                            <p class="widget-trustindex-score__title">
                                Баллы CO
                            </p>
                        </div>

                        <Skeleton v-if="loading" :theme="theme" class="widget-trustindex-score__skeleton" />
                        <p v-else class="widget-trustindex-score__value" :style="{ color: getStyleScore( coScore ) }">
                            {{ coScore }}
                        </p>
                    </div>

                    <div class="widget-trustindex-score__item">
                        <div class="widget-trustindex-score__name">
                            <IconRms class="widget-trustindex-score__icon" />
                            <p class="widget-trustindex-score__title">
                                Баллы RMS
                            </p>
                        </div>

                        <Skeleton v-if="loading" :theme="theme" class="widget-trustindex-score__skeleton" />
                        <p v-else class="widget-trustindex-score__value" :style="{ color: getStyleScore( rmsScore ) }">
                            {{ rmsScore }}
                        </p>
                    </div>

                    <div class="widget-trustindex-score__item">
                        <div class="widget-trustindex-score__name">
                            <IconSr class="widget-trustindex-score__icon" />
                            <p class="widget-trustindex-score__title">
                                Баллы SR
                            </p>
                        </div>

                        <Skeleton v-if="loading" :theme="theme" class="widget-trustindex-score__skeleton" />
                        <p v-else class="widget-trustindex-score__value" :style="{ color: getStyleScore( srScore ) }">
                            {{ srScore }}
                        </p>
                    </div>
                </div>

                <a :href="`https://m-strana.ru/trustindex/company/${ slug }/`" target="_blank" class="widget-trustindex-mstrana">
                    <IconLogo v-if="theme === 'light'" class="widget-trustindex-logo" />
                    <IconLogoWhite v-else class="widget-trustindex-logo" /> 
                    <span v-if="size === 'small'">TiMs - Trust Index MS</span>
                    <span v-else>TiMs - Trust Index MS (Индекс  надежности МС)</span>
                </a>
            </div>

            <IconHomeGreen v-if="size === 'large' && theme === 'light'" class="widget-trustindex-home-bg" />
            <IconHome v-else-if="size === 'large'" class="widget-trustindex-home-bg" />

            <a v-if="slug" :href="`https://m-strana.ru/trustindex/company/${ slug }/`" target="_blank" class="widget-trustindex-link" />
        </div>
    </template>
</template>

<script>
import IconTims from './Icon/Tims.vue'
import IconLogo from './Icon/Logo.vue'
import IconLogoWhite from './Icon/LogoWhite.vue'
import IconOsi from './Icon/Osi.vue'
import IconRms from './Icon/Rms.vue'
import IconCo from './Icon/Co.vue'
import IconSr from './Icon/Sr.vue'
import IconHome from './Icon/Home.vue'
import IconHomeGreen from './Icon/HomeGreen.vue'
import ProgressCircle from './ProgressCircle.vue'
import Skeleton from './Skeleton.vue'

export default {
    name: 'MstranaWidget',
    components: {
        IconTims,
        IconLogo,
        IconLogoWhite,
        IconOsi,
        IconRms,
        IconCo,
        IconSr,
        IconHome,
        IconHomeGreen,
        ProgressCircle,
        Skeleton
    },
    data() {
        return {
            type: 'client', // 'client' | 'mstrana'
            id: null,
            company: null,
            slug: null,
            colorScore: '#EA412C',
            size: 'large', // 'small' | 'large'
            theme: 'light', // 'light' | 'dark'
            loading: true,
            timsCircleSize: 62,
            widgetTypeMstranaResizeObserver: null,
            widgetTypeMstranaResizeRafId: null,
            widgetTypeMstranaLastWidth: null,
            widgetHeightObserver: null,
            widgetHeightRafId: null,
            widgetHeightLast: null,
            widgetHeightResizeHandler: null,
            widgetHeightBootstrapIntervalId: null
        }
    },
    computed:
    {
        osiScore()
        {
            return this.company ? this.prepareScore( this.company.osi_score ) || 0 : 0
        },
        rmsScore()
        {
            return this.company ? this.prepareScore( this.company.rms_score ) || 0 : 0
        },
        coScore()
        {
            return this.company ? this.prepareScore( this.company.co_score ) || 0 : 0
        },
        srScore()
        {
            return this.company ? this.prepareScore( this.company.sr_score ) || 0 : 0
        },
        timsScore()
        {
            return this.company ? this.prepareScore( this.company.final_score ) || 0 : 0
        }
    },
    async mounted() {
        this.parseUrlParams()
        await this.getCompany()
        this.initWidgetTypeMstranaResizeObserver()
        this.initWidgetHeightObserver()
    },
    beforeUnmount() {
        this.teardownWidgetTypeMstranaResizeObserver()
        this.teardownWidgetHeightObserver()
    },
    methods:
    {
        initWidgetHeightObserver() {
            if ( typeof window === 'undefined' ) {
                return
            }

            const postHeight = () => {
                const target = this.type === 'mstrana'
                    ? this.$refs.widgetTypeMstrana
                    : ( this.$el || document.body )
                if ( !target ) {
                    return
                }

                const rectHeight = Math.ceil( target.getBoundingClientRect().height || 0 )
                const scrollHeight = Math.ceil( target.scrollHeight || 0 )
                const height = Math.max( rectHeight, scrollHeight )

                if ( height === this.widgetHeightLast ) {
                    return
                }

                this.widgetHeightLast = height

                if ( window.parent && window.parent !== window ) {
                    window.parent.postMessage({ type: 'resize-widget', height }, '*')
                }
            }

            const schedulePost = () => {
                if ( this.widgetHeightRafId ) {
                    cancelAnimationFrame( this.widgetHeightRafId )
                }
                this.widgetHeightRafId = requestAnimationFrame( () => {
                    postHeight()
                    this.widgetHeightRafId = null
                })
            }

            this.$nextTick( () => {
                schedulePost()

                const target = this.type === 'mstrana'
                    ? this.$refs.widgetTypeMstrana
                    : ( this.$el || document.body )
                if ( target && typeof ResizeObserver !== 'undefined' ) {
                    this.widgetHeightObserver = new ResizeObserver( () => {
                        schedulePost()
                    })
                    this.widgetHeightObserver.observe( target )
                } else {
                    this.widgetHeightResizeHandler = schedulePost
                    window.addEventListener( 'resize', this.widgetHeightResizeHandler )
                }

                if ( document.fonts && typeof document.fonts.ready?.then === 'function' ) {
                    document.fonts.ready.then( schedulePost ).catch( () => {} )
                }

                let attempts = 0
                this.widgetHeightBootstrapIntervalId = setInterval( () => {
                    schedulePost()
                    attempts += 1
                    if ( attempts >= 8 ) {
                        clearInterval( this.widgetHeightBootstrapIntervalId )
                        this.widgetHeightBootstrapIntervalId = null
                    }
                }, 250 )
            })
        },
        teardownWidgetHeightObserver() {
            if ( this.widgetHeightObserver ) {
                this.widgetHeightObserver.disconnect()
                this.widgetHeightObserver = null
            }
            if ( this.widgetHeightRafId ) {
                cancelAnimationFrame( this.widgetHeightRafId )
                this.widgetHeightRafId = null
            }
            if ( this.widgetHeightBootstrapIntervalId ) {
                clearInterval( this.widgetHeightBootstrapIntervalId )
                this.widgetHeightBootstrapIntervalId = null
            }
            if ( typeof window !== 'undefined' ) {
                if ( this.widgetHeightResizeHandler ) {
                    window.removeEventListener( 'resize', this.widgetHeightResizeHandler )
                    this.widgetHeightResizeHandler = null
                }
            }
            this.widgetHeightLast = null
        },
        initWidgetTypeMstranaResizeObserver() {
            if ( this.type !== 'mstrana' || typeof ResizeObserver === 'undefined' ) {
                return
            }

            this.$nextTick( () => {
                const target = this.$refs.widgetTypeMstrana
                if ( !target ) {
                    return
                }

                const updateSize = width => {
                    const nextSize = width <= 304 ? 70 : width <= 504 ? 80 : 62
                    if ( this.timsCircleSize !== nextSize ) {
                        this.timsCircleSize = nextSize
                    }
                }

                this.widgetTypeMstranaResizeObserver = new ResizeObserver( entries => {
                    entries.forEach( entry => {
                        const nextWidth = Math.round( entry.contentRect.width )
                        if ( nextWidth === this.widgetTypeMstranaLastWidth ) {
                            return
                        }

                        this.widgetTypeMstranaLastWidth = nextWidth
                        if ( this.widgetTypeMstranaResizeRafId ) {
                            cancelAnimationFrame( this.widgetTypeMstranaResizeRafId )
                        }

                        this.widgetTypeMstranaResizeRafId = requestAnimationFrame( () => {
                            updateSize( nextWidth )
                            this.widgetTypeMstranaResizeRafId = null
                        })
                    })
                })

                updateSize( Math.round( target.getBoundingClientRect().width ) )
                this.widgetTypeMstranaResizeObserver.observe( target )
            })
        },
        teardownWidgetTypeMstranaResizeObserver() {
            if ( this.widgetTypeMstranaResizeObserver ) {
                this.widgetTypeMstranaResizeObserver.disconnect()
                this.widgetTypeMstranaResizeObserver = null
            }
            if ( this.widgetTypeMstranaResizeRafId ) {
                cancelAnimationFrame( this.widgetTypeMstranaResizeRafId )
                this.widgetTypeMstranaResizeRafId = null
            }
            this.widgetTypeMstranaLastWidth = null
        },
        prepareScore( score )
        {
            const value = typeof score === 'string' ? +score : score
            return Number( ( value / 10 ).toFixed( 1 ) )
        },
        getStyleScore( score, tims = false, circle = false )
        {
            if ( !tims && this.size === 'large' && this.theme === 'dark' )
            {
                return '#FFFFFF'
            }

            if ( this.loading || score >= 6.5 )
            {
                return circle && this.theme === 'dark' ? '#60C40A' : '#54B600'
            }

            return score >= 3 ? '#FF7E00' : '#EA412C'
        },
        getShadowForScoreProgress( score )
        {
            if ( this.loading || score >= 6.5 )
            {
                return '#A5EA6B'
            }

            return score >= 3 ? '#F0B378' : '#F18B7F'
        },
        getShadowForScore( score )
        {
            if ( this.loading || score >= 6.5 )
            {
                return this.theme === 'light' ? '0 19.81px 70px rgba(22, 199, 45, 0.25)' : '0 19.81px 70px rgba(5, 37, 12, 0.4)'
            }
            else if ( score >= 3 )
            {
                return this.theme === 'light' ? '0 19.81px 70px rgba(198, 120, 45, 0.4)' : '0 19.81px 70px rgba(133, 71, 12, 0.4)'
            }

            return this.theme === 'light' ? '0 19.81px 70px rgba(192, 47, 29, 0.4)' : '0 19.81px 70px rgba(181, 37, 19, 0.4)'
        },
        async getCompany()
        {
            try {
                const response = await fetch('https://m-strana.ru/trustindex/api/company/list/', {
                    method: 'POST',
                    body: JSON.stringify({ ids: [ this.id ] })
                })
                const data = await response.json()

                this.company = data.rows.find( item => item.id === this.id )
                this.colorScore = this.getStyleScore( this.prepareScore( this.company.final_score ) )

                await this.getSlug()
            } catch (error) {
                console.error('Ошибка загрузки компаний:', error)
            }
        },
        async getSlug()
        {
            if ( this.company.id )
            {
                try {
                    const response = await fetch('https://m-strana.ru/trustindex/api/company/slugs/get/by-company/', {
                        method: 'POST',
                        body: JSON.stringify({ company_id: this.company.id })
                    })
                    const data = await response.json()

                    this.slug = data.slug
                } catch (error) {
                    console.error('Ошибка загрузки slug:', error)
                } finally {
                    this.loading = false
                }
            }
        },
        parseUrlParams()
        {
            const params = new URLSearchParams(window.location.search)
            this.id = params.get('company') || null

            const paramSize = params.get('size')
            const paramTheme = params.get('theme')
            this.size = paramSize === 'small' || paramSize === 'large' ? paramSize : this.size
            this.theme = paramTheme === 'light' || paramTheme === 'dark' ? paramTheme : this.theme
            
            const paramType = params.get('type')
            this.type = paramType === 'client' || paramType === 'mstrana' ? paramType : this.type
        }
    }
}
</script>

<style>
.widget-type-mstrana {
    container-type: inline-size;
    container-name: widget-mstrana; 
    width: 100%;
    overflow: hidden;
    text-decoration: none;
    color: black;
    display: block;
}

.widget-type-mstrana-container {
    display: grid;
    grid-template-columns: 16fr 1fr 16fr 6fr;
    grid-template-rows: 1fr;
    height: 90px;
    gap: 16px;

    background-image: url('~/public/ms-widget-backdrop.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    padding: 14px 16px;

    @container widget-mstrana (max-width: 621px) {
        grid-template-columns: 16fr 1fr 19fr 3fr;
    }

    @container widget-mstrana (max-width: 528px) {
        grid-template-columns: 16fr 1fr 20fr 2fr;
    }
    
    @container widget-mstrana (max-width: 504px) {
        display: flex;
        flex-direction: column;
        height: auto;
    }
}

.widget-type-mstrana-separator {
    display: flex;
    justify-content: center;
    &::before {
        content: '';
        border-right: 1px solid #D7E9D6;
    }

    @container widget-mstrana (max-width: 504px) {
        height: 3px;
        width: 100%;
        
        &::before {
            width: 100%;
            border-right: none;
            border-bottom: 1px solid #D7E9D6;
        }
    }
}

.widget-type-mstrana-tims {
    display: flex;
    flex-direction: row;
    gap: 8px;

    @container widget-mstrana (max-width: 504px) {
        justify-content: space-between;
    }
}

.widget-type-mstrana-tims__snippet {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: start;
    text-align: start;
    text-decoration: none;
    color: black;
    justify-content: center;

    @container widget-mstrana (max-width: 504px) {
        gap: 10px;
    }
}

.widget-type-mstrana-tims__title {
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -2%;
    line-height: 100%;

    @container widget-mstrana (max-width: 504px) {
        font-size: 20px;
    }

    @container widget-mstrana (max-width: 304px) {
        font-size: 16px;
    }
}

.widget-type-mstrana-tims__link {
    color: #54B600;
    text-decoration: solid underline #B3D992 1px;
    text-underline-offset: 6px;
    font-size: 10px;

    &::after {
        content: '';
        display: inline-block;
        margin-left: 6px;
        position: relative;
        top: 4px;
        width: 12px;
        height: 12px;
        background-image: url('~/public/arrow-top-right.svg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }

    @container widget-mstrana (max-width: 504px) {
        font-size: 15px;
        
        &::after {
            width: 14px;
            height: 14px;
        }
    }

    @container widget-mstrana (max-width: 304px) {
        font-size: 12px;
        
        &::after {
            width: 12px;
            height: 12px;
        }
    }
}

.widget-type-mstrana-tims__circle {
    display: flex;
    align-items: center;
}

.widget-type-mstrana-tims__value {
    display: flex;
    gap: 2px;
    align-items: baseline;
}

.widget-type-mstrana-tims__score {
    color:#54B600;
    font-size: 18pt;
    font-weight: 600;
    letter-spacing: -0.05em;

    @container widget-mstrana (max-width: 504px) {
        font-size: 30px;
    }

    @container widget-mstrana (max-width: 304px) {
        font-size: 28px;
    }
}

.widget-type-mstrana-tims__icon {
    height: 14px;
    width: auto;

    @container widget-mstrana (max-width: 504px) {
        height: 18px;
    }

    @container widget-mstrana (max-width: 304px) {
        height: 16px;
    }
}

.widget-type-mstrana-indexes {
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.widget-type-mstrana-indexes__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.widget-type-mstrana-indexes__value {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.widget-type-mstrana-indexes__icon {
    color: #B6BEC5;
    width: 10px;
    height: auto;
}

.widget-type-mstrana-indexes__score {
    color:#54B600;
    font-size: 12pt;
    font-weight: 600;
    letter-spacing: -0.05em;
}

.widget-type-mstrana-indexes__title {
    font-size: 9px;
    font-weight: 500;

    @container widget-mstrana (max-width: 504px) {
        font-size: 12px;
    }
}

.widget-type-mstrana-logo {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: end;

    @container widget-mstrana (max-width: 504px) {
        display: none;
    }
}

.widget-type-mstrana-logo__icon {
    width: 18px;
    height: 18px;
    margin-top: 4px;

    @container widget-mstrana (max-width: 621px) {
        width: 30px;
        height: 30px;
    }

    @container widget-mstrana (max-width: 528px) {
        width: 24px;
        height: 24px;
    }
}

.widget-type-mstrana-logo__text {
    font-size: 9px;
    color: #878889;
    line-height: 95%;
    letter-spacing: -2%;
    text-align: start;
    
    @container widget-mstrana (max-width: 621px) {
        display: none;
    }
}


.widget-trustindex {
    position: relative;
    overflow: hidden;
    padding-top: 16px;
    background: linear-gradient( to bottom right, #F1FFFF, #F3FFE9 );
    border-radius: 30px;
}

.widget-trustindex.dark {
    background: linear-gradient( to bottom right, #00B679, #54B600 );
}

.widget-trustindex.small {
    padding-top: 13px;
    border-radius: 20px;
}

.widget-trustindex-title {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 40px;
    color: #000000;
    font-family: 'ProximaNova', sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -0.02em;
}

.widget-trustindex-title p {
    text-align: center;
}

.widget-trustindex.dark .widget-trustindex-title {
    color: #FFFFFF;
}

.widget-trustindex.small .widget-trustindex-title {
    height: 28px;
    font-size: 14px;
}

.widget-trustindex-title__company {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.widget-trustindex.light .widget-trustindex-title__company {
    color: #54B600;
}

.widget-trustindex-title__skeleton {
    height: 40px;
    width: 50%;
}

.widget-trustindex.small .widget-trustindex-title__skeleton {
    height: 28px;
    width: 70%;
}

.widget-trustindex-tims {
    position: relative;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    height: 117px;
    z-index: 1;
}

.widget-trustindex.small .widget-trustindex-tims {
    margin-bottom: 12px;
    height: 59px;
}

.widget-trustindex-tims__content {
    display: flex;
    align-items: baseline;
}

.widget-trustindex-tims__score {
    font-size: 49px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -0.05em;
}

.widget-trustindex.small .widget-trustindex-tims__score {
    font-size: 25px;
}

.widget-trustindex-tims__icon {
    margin-left: 4px;
    width: 13px;
}

.widget-trustindex.small .widget-trustindex-tims__icon {
    margin-left: 2px;
    width: 7px;
}

.widget-trustindex-tims__skeleton {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    right: 0;
    width: 117px;
    border-radius: 50%;
    overflow: hidden;
    transform: translateX(-50%);
}

.widget-trustindex.small .widget-trustindex-tims__skeleton {
    width: 59px;
}

.widget-trustindex-content {
    width: 100%;
    border-top: 1px solid #D7E9D6;
}

.widget-trustindex.dark .widget-trustindex-content {
    border-top: 1px solid rgba(215, 233, 214, 0.5);
}

.widget-trustindex.small .widget-trustindex-content {
    background: rgba(255, 255, 255, 0.5);
}

.widget-trustindex-mstrana {
    position: relative;
    padding: 12px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #728D7F;
    font-family: 'ProximaNova', sans-serif;
    font-size: 10px;
    line-height: 95%;
    letter-spacing: -0.02em;
    z-index: 1;
}

.widget-trustindex.small .widget-trustindex-mstrana {
    padding: 11px 0;
}

.widget-trustindex.dark .widget-trustindex-mstrana {
    color: #FFFFFF;
}

.widget-trustindex-logo {
    margin-right: 9px;
    width: 18px;
    height: 18px;
}

.widget-trustindex.small .widget-trustindex-logo {
    margin-right: 6px;
    width: 16px;
    height: 16px;
}

.widget-trustindex-score {
   display: grid;
   gap: 1px;
}

.widget-trustindex-score__item {
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    background: rgba(255, 255, 255, 0.5);
}

.widget-trustindex.dark .widget-trustindex-score__item{
    background: rgba(255, 255, 255, 0.1);
}

.widget-trustindex-score__name {
    display: flex;
    align-items: center;
}

.widget-trustindex-score__icon {
    width: 13px;
    color: #AAB1B7;
}

.widget-trustindex.dark .widget-trustindex-score__icon {
    color: #FFFFFF;
}

.widget-trustindex-score__title {
    margin-left: 8px;
    color: #878889;
    font-size: 13px;
    font-weight: 500;
    line-height: 120%;
}

.widget-trustindex.dark .widget-trustindex-score__title {
    color: #FFFFFF;
}

.widget-trustindex-score__value {
    font-size: 15px;
    font-weight: 500;
    line-height: 120%;
}

.widget-trustindex-score__skeleton {
    width: 60px;
    height: 18px;
}

.widget-trustindex-home-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
}

.widget-trustindex-link {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: transparent;
    text-decoration: none;
    z-index: 1;
}
</style>
